import { api } from "@";

// Fetch data from the server
const fetch = async (endpoint, time) => {
  try {
    const { data } = await api.post(`/api/AdminOrderDashboard/${endpoint}`, {
      searchTimeInterval: parseInt(time),
    });
    return data;
  } catch (error) {
    console.log("🚀 ~ fetch ~ error:", error);
  }
};

export const getOrders = (time = 3) => fetch("orders", time);
export const getGiftOrders = (time = 3) => fetch("gift-orders", time);
export const getAbandonedCarts = (time = 3) => fetch("abandoned-carts", time);
export const getRecurrentOrders = (time = 3) => fetch("recurrent-orders", time);
export const getClients = (time = 3) => fetch("new-users-percentage", time);
export const getNewOrders = (time = 3) => fetch("new-orders-percentage", time);
export const getVerifications = (time = 3) => fetch("verifications", time);
export const getMostDonatedProjects = (time = 3) =>
  fetch("most-requested-projects", time);
export const getCardOrders = (time = 3) => fetch("card-orders", time);
export const getBankOrders = (time = 3) => fetch("bank-orders", time);
export const getOrdersAmount = (time = 3) => fetch("orders-amount", time);
export const getBestClients = (time = 3) => fetch("best-users", time);
export const getDriversVerifications = (time = 3) =>
  fetch("drivers-verifications", time);
export const getProjectsVerifications = (time = 3) =>
  fetch("most-verified-projects", time);
